// Casamento do codigo de servico lido do PDF com os codigos cadastrados.
// Funcao unica para a inclusao manual (lista de CNAEs do combo "Servico") e
// para o simulador de regras (chaves do de-para de produto, ZOL tipo 1): o
// mesmo documento precisa chegar no mesmo codigo nas duas telas.
//
// O PDF imprime o codigo em formatos variados ("11.04.01", "110401",
// "1104.01") e o cadastro guarda "1104.01"; por isso compara so os digitos.
// Devolve o codigo como esta no cadastro, ou '' sem correspondencia.

export function casarCodigoServico(raw: string, codigos: string[]): string {
  if (!raw) { return ''; }
  const digitos = raw.replace(/\D/g, '');
  const achado = codigos.find(c => {
    const v = String(c);
    return v.replace(/\D/g, '') === digitos || v === raw;
  });
  return achado ?? '';
}
